"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toISODate = exports.toDayOfWeek = exports.getTimestampWasAgo = exports.getTimeZonesInCountries = exports.formatToDateInputMoment = exports.formatDateString = exports.formatDateInputString = exports.formatDateField = exports.abbreviateMonthWithPeriod = exports.WEEKDAYS_ORDER_SUNDAY_START = exports.WEEKDAYS_ORDER = exports.DateStringFormatEnum = exports.DATE_NO_TIME_FORMAT = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var _types = require("../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WEEKDAYS_ORDER = [_types.DayOfWeek.Monday, _types.DayOfWeek.Tuesday, _types.DayOfWeek.Wednesday, _types.DayOfWeek.Thursday, _types.DayOfWeek.Friday, _types.DayOfWeek.Saturday, _types.DayOfWeek.Sunday];
exports.WEEKDAYS_ORDER = WEEKDAYS_ORDER;
var WEEKDAYS_ORDER_SUNDAY_START = [_types.DayOfWeek.Sunday, _types.DayOfWeek.Monday, _types.DayOfWeek.Tuesday, _types.DayOfWeek.Wednesday, _types.DayOfWeek.Thursday, _types.DayOfWeek.Friday, _types.DayOfWeek.Saturday];
exports.WEEKDAYS_ORDER_SUNDAY_START = WEEKDAYS_ORDER_SUNDAY_START;
var DATE_NO_TIME_FORMAT = 'YYYY-MM-DD';
exports.DATE_NO_TIME_FORMAT = DATE_NO_TIME_FORMAT;
var DateStringFormatEnum = /*#__PURE__*/function (DateStringFormatEnum) {
  DateStringFormatEnum[DateStringFormatEnum["DATE_STYLE_SHORT"] = 0] = "DATE_STYLE_SHORT";
  DateStringFormatEnum[DateStringFormatEnum["MM_DD_YY"] = 1] = "MM_DD_YY";
  DateStringFormatEnum[DateStringFormatEnum["MM_DD_YYYY"] = 2] = "MM_DD_YYYY";
  DateStringFormatEnum[DateStringFormatEnum["YYYY_MM_DD"] = 3] = "YYYY_MM_DD";
  return DateStringFormatEnum;
}({});
/**
 * Utility function using built-in Javascript APIs to format Date strings.
 * Expand functionality by adding enums to `DateStringFormatEnum` and cases to
 * the body of the function using `Intl.DateTimeFormatOptions` options.
 * @param {string | undefined} dateString
 * @param {DateStringFormatEnum} format
 * @param {string?} timezone
 * @returns {string} formattedDateString
 */
exports.DateStringFormatEnum = DateStringFormatEnum;
var formatDateString = function formatDateString(dateString, format, timezone) {
  if (!dateString) {
    return '';
  }
  var options = {
    // If timezone is undefined, it defalts to local time. This is useful to
    // display birthdates as 'utc' timezone because that's how they are stored
    // in the database
    timeZone: timezone
  };
  switch (format) {
    case DateStringFormatEnum.DATE_STYLE_SHORT:
      {
        options = _objectSpread(_objectSpread({}, options), {}, {
          dateStyle: 'short'
        });
        break;
      }
    case DateStringFormatEnum.MM_DD_YY:
      {
        options = _objectSpread(_objectSpread({}, options), {}, {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit'
        });
        break;
      }
    case DateStringFormatEnum.MM_DD_YYYY:
      {
        options = _objectSpread(_objectSpread({}, options), {}, {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        });
        break;
      }
    default:
  }
  var formatter = new Intl.DateTimeFormat('en-US', options);
  var date = new Date(dateString);
  return formatter.format(date);
};
exports.formatDateString = formatDateString;
var toDayOfWeek = function toDayOfWeek(date) {
  return (0, _lodash.toLower)((0, _moment.default)(date).format('dddd'));
};
exports.toDayOfWeek = toDayOfWeek;
var toISODate = function toISODate(date) {
  return (0, _moment.default)(date).format(DATE_NO_TIME_FORMAT);
};

// Must be same format as mask defined in our DateInput component.
exports.toISODate = toISODate;
var DATE_INPUT_MASK_FORMAT = 'MM / DD / YYYY';
var formatDateField = function formatDateField(date) {
  return _moment.default.utc(date).format(DATE_INPUT_MASK_FORMAT);
};
exports.formatDateField = formatDateField;
var formatDateInputString = function formatDateInputString(date) {
  return date ? _moment.default.utc(date, DATE_INPUT_MASK_FORMAT, true).toISOString() : undefined;
};
exports.formatDateInputString = formatDateInputString;
var formatToDateInputMoment = function formatToDateInputMoment(date) {
  return _moment.default.utc(date, DATE_INPUT_MASK_FORMAT, true);
};

/**
 * When shortening month names, May is an edge case because it is too short too
 * be abbreviated. This util conditionally adds a period to the month abbreviation.
 * @param {moment.Moment} date The moment instance to format
 * @returns {string}
 */
exports.formatToDateInputMoment = formatToDateInputMoment;
var abbreviateMonthWithPeriod = function abbreviateMonthWithPeriod(date) {
  var fullMonthString = date.format('MMMM');
  var abbrMonthString = date.format('MMM');
  return "".concat(abbrMonthString).concat(fullMonthString !== abbrMonthString ? '.' : '');
};
exports.abbreviateMonthWithPeriod = abbreviateMonthWithPeriod;
var getTimestampWasAgo = function getTimestampWasAgo(timestamp) {
  var diffDays = _moment.default.utc().diff(timestamp, 'days');
  var template = function template(count, unit) {
    return "".concat(count, " ").concat(unit).concat(count === 1 ? '' : 's');
  };
  if (diffDays) {
    return template(diffDays, 'day');
  }
  var diffHours = _moment.default.utc().diff(timestamp, 'hours');
  if (diffHours) {
    return template(diffHours, 'hour');
  }
  return template(_moment.default.utc().diff(timestamp, 'minutes'), 'minute');
};

// Can use moment.tz.countries() to get list of available country codes
exports.getTimestampWasAgo = getTimestampWasAgo;
var getTimeZonesInCountries = function getTimeZonesInCountries(countries) {
  return (0, _lodash.chain)(countries).flatMap(function (countryCode) {
    return _moment.default.tz.zonesForCountry(countryCode);
  }).uniq().sort().value();
};
exports.getTimeZonesInCountries = getTimeZonesInCountries;